import { AxiosRequestConfig } from "axios";

import { get, post } from "@api/httpClient";

import { FrontendTemplateModel } from "@shared/models/FrontendTemplate.model";

/**
 * Retrieves more information about a specific frontend template.
 */
export async function getFrontendTemplate(
  templateId: string,
  options: AxiosRequestConfig,
) {
  const { data } = await get<FrontendTemplateModel>(
    `/api/dock-public/v2/consumer/frontend-templates/${templateId}`,
    options,
  );

  return data;
}

export async function getFrontendTemplates(options: AxiosRequestConfig) {
  const { data } = await get<FrontendTemplateModel[]>(
    `/api/dock-public/v2/consumer/frontend-templates`,
    options,
  );

  return data;
}

export interface SwitchFrontendTemplatePayload {
  seriesCode: string;
  forceReset: boolean;
}

export async function postSwitchFrontendTemplate({
  applicantExamId,
  resultId,
  options,
}: {
  applicantExamId: number;
  resultId: string;
  options: AxiosRequestConfig<SwitchFrontendTemplatePayload>;
}) {
  await post<void>(
    `/api/applicants/exams/${applicantExamId}/results/${resultId}/frontend/switch-frontend-template`,
    options,
  );
}
